import React from 'react'
import {Stack, TextField, Typography, SxProps, Theme} from '@mui/material'
import {CONTROL_HEIGHT, NEUTRAL_SCALE} from 'src/theme-new/tokens'

interface TextFieldNewProps {
  value: string
  onChange: (value: string) => void
  name?: string
  label?: string
  placeholder?: string
  type?: 'text' | 'email' | 'tel' | 'password'
  autoComplete?: string
  autoFocus?: boolean
  fullWidth?: boolean
  required?: boolean
  disabled?: boolean
  error?: boolean
  helperText?: string
  endAdornment?: React.ReactNode
  onKeyDown?: React.KeyboardEventHandler<HTMLInputElement>
  onKeyUp?: React.KeyboardEventHandler<HTMLInputElement>
  onBlur?: React.FocusEventHandler<HTMLInputElement>
  inputRef?: React.Ref<HTMLInputElement>
  sx?: SxProps<Theme>
}

export default function TextFieldNew({
  value,
  onChange,
  name,
  label,
  placeholder,
  type = 'text',
  autoComplete,
  autoFocus,
  fullWidth,
  required,
  disabled,
  error,
  helperText,
  endAdornment,
  onKeyDown,
  onKeyUp,
  onBlur,
  inputRef,
  sx,
}: TextFieldNewProps): JSX.Element {
  return (
    <Stack spacing={0.5} sx={{width: fullWidth ? '100%' : undefined, ...sx}}>
      {label && (
        <Typography variant="caption" sx={{fontWeight: 600, color: NEUTRAL_SCALE[700], textTransform: 'uppercase', letterSpacing: '0.05em'}}>
          {label}{required && ' *'}
        </Typography>
      )}
      <TextField
        size="small"
        value={value}
        onChange={e => onChange(e.target.value)}
        onBlur={onBlur}
        name={name}
        placeholder={placeholder}
        type={type}
        autoComplete={autoComplete}
        autoFocus={autoFocus}
        fullWidth={fullWidth}
        required={required}
        disabled={disabled}
        error={error}
        inputRef={inputRef}
        InputProps={{endAdornment, onKeyDown, onKeyUp}}
        sx={{
          '& .MuiOutlinedInput-root': {
            height: CONTROL_HEIGHT,
            borderRadius: '8px',
            backgroundColor: '#fff',
            '& fieldset': {borderColor: error ? 'error.main' : NEUTRAL_SCALE[200]},
            '&:hover fieldset': {borderColor: error ? 'error.main' : NEUTRAL_SCALE[300]},
            '&.Mui-focused fieldset': {borderColor: error ? 'error.main' : 'primary.main'},
          },
          '& .MuiInputBase-input': {padding: '0 14px'},
          '& .MuiOutlinedInput-root.Mui-disabled': {backgroundColor: NEUTRAL_SCALE[100]},
          '& .MuiInputBase-input.Mui-disabled': {WebkitTextFillColor: NEUTRAL_SCALE[700]},
        }}
      />
      {helperText && (
        <Typography variant="caption" sx={{color: error ? 'error.main' : NEUTRAL_SCALE[500]}}>
          {helperText}
        </Typography>
      )}
    </Stack>
  )
}
